var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "pull-up mx-auto",
      staticStyle: { "border-top": "4px solid #60bb46", height: "100%" },
      attrs: { "fill-height": "" }
    },
    [
      _c(
        "v-card-title",
        {
          staticClass: "overline d-flex justify-center pb-3",
          staticStyle: { color: "#464855" }
        },
        [
          _c(
            "h3",
            {
              staticClass: "text-center",
              staticStyle: { "word-break": "break-word" }
            },
            [_vm._v(" Disponibilidad del Sistema de Control Ambiental ")]
          )
        ]
      ),
      _c(
        "v-card-text",
        {
          staticClass: "d-flex justify-center pt-2",
          attrs: { collapse: "", show: "", "fill-height": "" }
        },
        [
          _c(
            "div",
            [
              _c(
                "v-row",
                {
                  class: {
                    "mx-auto d-flex justify-center": this.$vuetify.breakpoint
                      .smAndDown
                  }
                },
                _vm._l(_vm.dataCentersArray, function(i) {
                  return _c("apexchart", {
                    key: i.id,
                    staticClass: "px-0 mx-0 system-availability",
                    attrs: {
                      options: _vm.chartOptions(i.id),
                      series: [100],
                      type: "radialBar"
                    }
                  })
                }),
                1
              ),
              _c(
                "v-row",
                { attrs: { "fill-width": "" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "text-center py-0 my-0",
                      attrs: { lg: "6", md: "6" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "overline pt-0 mt-0 mb-1 pb-1",
                          staticStyle: { color: "#464855" }
                        },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { staticClass: "py-1", attrs: { cols: "12" } },
                                [_c("h4", [_vm._v("CTDC")])]
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            [
                              _c("v-col", { attrs: { cols: "2" } }),
                              _c(
                                "v-col",
                                { staticClass: "py-1", attrs: { cols: "8" } },
                                [
                                  _c("v-progress-linear", {
                                    attrs: {
                                      value: 100,
                                      "background-opacity": "0.2",
                                      rounded: "",
                                      height: "5",
                                      color: "#00AAB8"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("v-col", { attrs: { cols: "2" } })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "text-center py-0 my-0",
                      attrs: { lg: "6", md: "6" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "overline pt-0 mt-0 mb-1 pb-1",
                          staticStyle: { color: "#464855" }
                        },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { staticClass: "py-1", attrs: { cols: "12" } },
                                [_c("h4", [_vm._v("CDTV")])]
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            [
                              _c("v-col", { attrs: { cols: "2" } }),
                              _c(
                                "v-col",
                                { staticClass: "py-1", attrs: { cols: "8" } },
                                [
                                  _c("v-progress-linear", {
                                    attrs: {
                                      value: 100,
                                      "background-opacity": "0.2",
                                      rounded: "",
                                      height: "5",
                                      color: "#60BB46"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("v-col", { attrs: { cols: "2" } })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }